<script>
export default {
  props: {
    iconSize: {
      type: String,
      required: false,
      default: "25"
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    hasSearchBox: {
      type: Boolean,
      required: false,
      default: true
    },
    search: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: false
    },
    buttonRoute: {
      type: [Object, String],
      required: false,
      default: ""
    },
    buttonTextAction: {
      type: [Function, Boolean],
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <v-card-title class="d-flex align-end px-0" primary-title>
    <div class="d-flex align-center">
      <v-icon color="black" :size="iconSize" class="mr-2">{{ icon }}</v-icon>
      <h3 class="font-weight-regular text-uppercase">{{ title }}</h3>
      <v-btn
        v-if="buttonText"
        rounded
        outlined
        small
        color="accent"
        class="ml-3"
        @click="buttonTextAction()"
        :to="buttonRoute"
        >{{ buttonText }}</v-btn
      >
    </div>

    <v-spacer></v-spacer>

    <v-text-field
      v-if="hasSearchBox"
      v-validate="'min:3'"
      name="search"
      :error="errors.has('search')"
      :error-messages="errors.first('search')"
      :value="search"
      @keyup.enter="$emit('search', $event.target.value)"
      append-icon="search"
      label="Buscar..."
      hide-details
    ></v-text-field>
  </v-card-title>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/DataTable/Title.vue